import type { ThemeOptions } from '@material-ui/core/styles';

const themeColor = '#FF3975';

export default {
  palette: {
    background: {
      default: '#fff',
    },
    primary: {
      main: themeColor,
      light: '#FFE8EF',
      dark: '#E81656',
    },
    secondary: {
      main: '#FC98A0',
      dark: '#743649',
    },
    text: {
      primary: '#0D202F',
      secondary: '#3B4F60',
    },
    grey: {
      200: '#6b7A86',
      250: '#6e7e9a',
      270: '#d9e0e9',
      300: '#E2E6EA',
      500: '#f5f6f8',
    },
  },
  typography: {
    fontFamily: ['CircularStd', 'Circular', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    fontSize: 12.25,
    body1: {
      lineHeight: '1.25rem',
      letterSpacing: 'normal',
      fontWeight: 'normal',
    },
    h3: {
      fontWeight: 500,
      fontSize: '2.25rem',
      lineHeight: '3rem',
    },
    h4: {
      fontWeight: 500,
      fontSize: '1.375rem',
      lineHeight: '2.0625rem',
      // Override for smaller screens (iPhone SE).
      '@media (max-height: 810px)': {
        lineHeight: '1.8rem',
      },
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.469em',
      lineHeight: '2.0625rem',
      // Override for smaller screens (iPhone SE).
      '@media (max-height: 810px)': {
        lineHeight: '1.8rem',
      },
    },
    subtitle2: {
      fontSize: '0.875rem',
      fontWeight: 450,
      lineHeight: '1.125em',
    },
    subtitle1: {
      lineHeight: '1.125em',
    },
  },

  /** Global CSS */
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          scrollBehavior: 'smooth',
          margin: 0,
          WebkitTapHighlightColor: 'transparent',
        },
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: '#283036b3',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        backgroundColor: 'white',
        fontWeight: 450,
        fontSize: '0.9rem',
        letterSpacing: 'normal',
        borderRadius: '0.5em',
        padding: '1em 2em',
        '&$:hover': {
          opacity: '0.9',
        },
      },
      contained: {
        '&$disabled': {
          backgroundColor: '#6B7A86',
          color: 'white',
        },
        '&:hover': {
          '&$disabled': {
            backgroundColor: '#6B7A86',
            color: 'white',
          },
        },
      },
      outlined: {
        padding: '1em 2em',
      },
      textPrimary: {
        '&:hover': {
          backgroundColor: 'white',
          opacity: '0.9',
        },
        '@media (hover:none)': {
          '&:hover': {
            // Can't override default MUI theme unless you use !important
            backgroundColor: 'white !important',
          },
        },
      },
      text: {
        padding: '1em 2em',
      },
    },
    MuiInputBase: {
      root: {
        height: '3.571em',
        backgroundColor: 'white',
        borderRadius: '0.653em',
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: '0.653em',
        '&$focused $notchedOutline': {
          borderColor: '#3B4F60',
          borderWidth: '0.071em',
        },
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          borderRadius: 'inherit',
        },
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        color: themeColor,
        '&$checked': {
          color: themeColor,
        },
      },
    },
    // MuiInputLabel: {
    //   '&$shrink': {
    //     top: '-0.0625rem',
    //   },
    // },
    MuiFormLabel: {
      root: {
        '&$focused': {
          color: '#3B4F60',
        },
      },
    },
    MuiAlert: {
      root: {
        borderRadius: '0.5rem',
        alignItems: 'center',
      },
      standardError: {
        color: themeColor,
      },
      icon: {
        '&&': {
          color: themeColor,
        },
      },
    },
  },
} as ThemeOptions;
